import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cb93adc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed, onBeforeUnmount, ref } from "vue";
import { IonIcon } from "@ionic/vue";
import { searchOutline } from "ionicons/icons";
import { Tag } from "@/types/frontendTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'TaggedImage',
  props: {
    tags: null,
    src: null,
    openTag: null
  },
  emits: ["update:openTag"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:openTag', value: Tag | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    tags?: Tag[]
    src: string
    openTag: Tag | null
}





const clickedTagId = ref<string>('')

// const changeTagColor = (tag: Tag) => {
//     clickedTagId.value = tag.id
// }

const openTagValue = computed({
        get() {
            return props.openTag
        },
        set(value: Tag | null) {
            emit('update:openTag', value)
            clickedTagId.value = value?.id || ''
        }
    }
)

onBeforeUnmount(() => {
    openTagValue.value = null
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "image-container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (openTagValue.value = null))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle([{"height":"100%","width":"0"}, {
                position: 'absolute',
                top: `calc(${tag.yCoordinate}% - 20px)`,
                left: `calc(${tag.xCoordinate}% - 20px)`
            }])
      }, [
        (!(tag.id === clickedTagId.value))
          ? (_openBlock(), _createBlock(_unref(IonIcon), {
              key: 0,
              class: "tag-icon icon-shadow",
              color: "light",
              icon: _unref(searchOutline),
              onClick: ($event: any) => {$event.stopPropagation(); openTagValue.value =  tag}
            }, null, 8, ["icon", "onClick"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_unref(IonIcon), {
                class: "tag-icon icon-shadow",
                color: "tertiary",
                icon: _unref(searchOutline),
                onClick: ($event: any) => {$event.stopPropagation(); openTagValue.value =  tag}
              }, null, 8, ["icon", "onClick"]),
              _createElementVNode("div", {
                class: "vertical-line",
                style: _normalizeStyle({
                    height: `calc(100% - ${tag.yCoordinate}% + 20px)`
                })
              }, null, 4)
            ], 64))
      ], 4))
    }), 128)),
    _createElementVNode("img", {
      src: __props.src,
      ref: "image",
      style: {"width":"100%","border-radius":"10px"},
      alt: ""
    }, null, 8, _hoisted_1)
  ]))
}
}

})